import { render } from "./ZocialView.vue?vue&type=template&id=59467294"
import script from "./ZocialView.vue?vue&type=script&lang=js"
export * from "./ZocialView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__